export default __webpack_public_path__ + "static/blob12-243bbcf5940bb5ccdbde6883e37c7df0.svg";